export const LOADING = 'spendingAccounts/LOADING';
export const GET_HEALTH_USAGE = 'spendingAccounts/GET_HEALTH_USAGE';
export const ADD_HEALTH_USAGE = 'spendingAccounts/ADD_HEALTH_USAGE';
export const GET_LIFESTYLE_CLAIMS = 'spendingAccounts/GET_LIFESTYLE_CLAIMS';
export const ADD_LIFESTYLE_CLAIM = 'spendingAccounts/ADD_LIFESTYLE_CLAIM';
export const GET_LSA_CLAIMS_SUCCESS = 'spendingAccounts/GET_LSA_CLAIMS_SUCCESS';
export const GET_HSA_CLAIMS_SUCCESS = 'spendingAccounts/GET_HSA_CLAIMS_SUCCESS';